import { eventTypes } from "./analytics";
import { isInternalLink } from "./utils";

const DCSURI_PREFIX = "footer:";

let FIRST_TIME = true;

const isAdobeEnabled = () => window._satellite && window._satellite.track;

const CLIENT_BUTTON_CLASSES = {
  INITIALIZING: "initializing",
  OPEN: "open",
  CLOSE: "close",
  MINIMIZED: "minimized",
  ERROR: "error",
};

const handleWidgetOpen = (type, data, digitalData) => {
  let link = {};
  let dcsuri = "";
  if (data.name === CLIENT_BUTTON_CLASSES.OPEN) {
    link = data.buttonName
      ? {
          text: "expand",
          action: "online-chat-expand",
          label: preprocessText(data.buttonName),
        }
      : {
          text: "expand",
          action: "online-chat-expand",
        };
    dcsuri = `${DCSURI_PREFIX}online-chat-expand`;
    if (FIRST_TIME) {
      link = {
        category: "content",
        section: "footer",
        label: "chat-icon",
        text: "lets-chat",
        action: "online-chat",
      };
      dcsuri = `${DCSURI_PREFIX}lets-chat`;
      FIRST_TIME = false;
    }
  } else if (data.name === CLIENT_BUTTON_CLASSES.CLOSE) {
    link = data.buttonName
      ? {
          text: "collapse",
          action: "online-chat-close",
          label: preprocessText(data.buttonName),
        }
      : {
          text: "close",
          action: "online-chat-close",
        };
    dcsuri = `${DCSURI_PREFIX}online-chat-close`;
  } else if (data.name === CLIENT_BUTTON_CLASSES.MINIMIZED) {
    link = data.buttonName
      ? {
          text: "collapse",
          action: "online-chat-minimize",
          label: preprocessText(data.buttonName),
        }
      : {
          text: "minimize",
          action: "online-chat-minimize",
        };
    dcsuri = `${DCSURI_PREFIX}online-chat-minimize`;
  }
  Object.assign(digitalData.link, link);
  digitalData.page.dcsuri = dcsuri;
};

const handleUserUtterance = (type, data, digitalData) => {
  console.debug("there");
  Object.assign(digitalData.link, {
    text: "question-submit",
    action: "online-chat-question-submit",
    category: "content",
    section: data.method === "voice" ? "voice-chat" : digitalData.link.section,
  });
  digitalData.page.dcsuri = `${DCSURI_PREFIX}question-submit`;
};

const handleSuggestionClick = (type, data, digitalData) => {
  Object.assign(digitalData.link, {
    action: "online-chat-question-internal-link",
    category: "content",
    section: "chat",
    label: "suggestion",
  });

  // Only support `url` and `phone`.
  if (data.url) {
    digitalData.page.dcsuri = `${DCSURI_PREFIX}${data.url || data.displayText}`;
    digitalData.link.text = preprocessText(data.displayText || data.url);
    if (!isInternalLink(data.url)) {
      digitalData.link.action = "online-chat-question-external-link";
      return "external-link-event";
    }
  } else if (data.phone) {
    digitalData.page.dcsuri = `${DCSURI_PREFIX}${data.phone}`;
    digitalData.link.text = preprocessText(data.displayText || data.phone);
  } else if (data.displayText) {
    digitalData.page.dcsuri = `${DCSURI_PREFIX}chat-suggestion-${preprocessText(
      data.displayText
    )}`;
    digitalData.link.text = preprocessText(data.displayText);
  }
};

const handleUrlTagClick = (type, data, digitalData) => {
  const isInternal = isInternalLink(data.url);
  Object.assign(digitalData.link, {
    text: preprocessText(data.url),
    action: isInternal
      ? "online-chat-question-internal-link"
      : "online-chat-question-external-link",
  });
  digitalData.page.dcsuri = `${DCSURI_PREFIX}${preprocessText(data.url)}`;
  if (isInternal) {
    return "external-link-event";
  }
};

const handlePhoneTagClick = (type, data, digitalData) => {
  Object.assign(digitalData.link, {
    text: preprocessText(data.phone),
    action: "online-chat-question-internal-link",
  });
  digitalData.page.dcsuri = `${DCSURI_PREFIX}${data.phone}`;
};

const handleError = (type, data, digitalData) => {
  Object.assign(digitalData.link, {
    category: "internal",
    text: preprocessText(data.message),
    action: "error",
  });
  digitalData.page.dcsuri = `${DCSURI_PREFIX}error`;
};

const preprocessText = (str) =>
  str
    .toLowerCase()
    .trim()
    .replace(/(:\/\/)|\.| /gi, "-");

const sendDTMEvent = (isEnabled) => ({ type, data }) => {
  if (!isEnabled || !isAdobeEnabled()) {
    return;
  }
  const eventToHandlers = {
    [eventTypes.WIDGET_CLICK]: handleWidgetOpen,
    [eventTypes.SUGGESTION_CLICK]: handleSuggestionClick,
    [eventTypes.USER_UTTERANCE]: handleUserUtterance,
    [eventTypes.URL_TAG_CLICK]: handleUrlTagClick,
    [eventTypes.PHONE_TAG_CLICK]: handlePhoneTagClick,
    [eventTypes.ERROR]: handleError,
  };
  if (!window.digitalData) {
    console.debug("no digitalData");
    return;
  }
  const internalDigitalData = JSON.parse(JSON.stringify(window.digitalData));
  Object.assign(window.digitalData, {
    link: {
      category: "content",
      section: "footer",
      label: "chat",
    },
  });
  if (eventToHandlers[type]) {
    const eventName =
      eventToHandlers[type](type, data, window.digitalData) ||
      "internal-link-event";
    window._satellite.track(eventName);
  }
  window.digitalData = internalDigitalData;
};

export { sendDTMEvent };
